import { navigate } from '@reach/router'

import { LIFESTYLE_STEP_NAMES, LIFESTYLE_URL } from './constants'

export function getLifestyleStageUrl(stageIdx: number) {
  stageIdx--

  return stageIdx < 0 ? LIFESTYLE_URL : `${LIFESTYLE_URL}/${LIFESTYLE_STEP_NAMES[stageIdx]}`
}

export function navigateToLifestyleStage(stageIdx: number) {
  return navigate(getLifestyleStageUrl(stageIdx))
}
